var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "flex-align steps flex-spacebetween" },
    [
      _c("span", { staticClass: "steps-left" }, [_vm._v(_vm._s(_vm.title))]),
      _c(
        "el-steps",
        {
          staticStyle: { width: "60%" },
          attrs: { active: _vm.active, "align-center": "" },
        },
        _vm._l(_vm.defaultOptions, function (item, index) {
          return _c("el-step", { key: index, attrs: { title: item } })
        }),
        1
      ),
      _c(
        "div",
        { staticClass: "steps-right flex-align-end" },
        [_vm._t("right")],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }